import BlockSettings from '../../../models/BlockSettings';
import BlockImageItemData from './BlockImageListItemData';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockImageListData {
  imageList: BlockImageItemData[];
  settings: BlockSettings;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockImageListData {
  export function make(imageList: BlockImageItemData[], settings: BlockSettings, url?: string): BlockImageListData {
    return {
      imageList,
      settings: BlockSettings.make(settings.align, settings.justify),
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(image = ''): BlockImageListData {
    return make(
      [
        BlockImageItemData.getDefault(image),
        BlockImageItemData.getDefault(image),
        BlockImageItemData.getDefault(image),
        BlockImageItemData.getDefault(image),
      ],
      BlockSettings.getDefault(),
    );
  }
}

export default BlockImageListData;
